<template>
    <v-dialog v-model="dialog" width="500" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="semester"
                                label="Semester"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="semesterData"
                                item-title="name"
                                item-value="name"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="schoolyear"
                                label="Schoolyear"
                                :rules="[formRules.required, newFormRules.academicYearFormat]"
                                hint="Ex: 2024-2025"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            semesterData: [ 
                {name:'1st Semester'}, 
                {name:'2nd Semester'}, 
                {name:'Summer'}
            ],

            id: null,
            semester: null,
            schoolyear: null,

            newFormRules: {
                academicYearFormat: (value) => {
                    const match = /^(\d{4})-(\d{4})$/.exec(value);
                    if (!match) return 'Format must be YYYY-YYYY';
                    
                    const startYear = parseInt(match[1], 10);
                    const endYear = parseInt(match[2], 10);

                    return endYear === startYear + 1 || 'The second year must be exactly one year after the first';
                }
            },
        }
     },
     methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'Semester and Schoolyear'
            this.dialog_sub_title = 'Add new semester and schoolyear'
            this.action = 'add'
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Semester and Schoolyear'
            this.dialog_sub_title = 'Add new semester and schoolyear'
            this.action = 'edit'

            this.id = data.id
            this.semester = data.semester
            this.schoolyear = data.schoolyear
            this.isActive = data.isActive
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    semester: this.semester,
                    schoolyear: this.schoolyear,
                    isActive: this.isActive,
                }

                const token = localStorage.getItem('aums-token')
                if(this.action == 'add')[
                    axios.post(process.env.VUE_APP_SERVER_URL + '/semester-schoolyear', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 201){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Semester and Schoolyear successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                ]
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/semester-schoolyear', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 201){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Semester and Schoolyear successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>